module.exports = require('../../../../../node_modules/@pkuanvil/nodebb-plugin-poll/public/js/poll/serializer.js');